import React, { useState } from "react";
import { useMutation } from "@tanstack/react-query";
import { deleteUserResume } from "../../../services/api/digitalAsset";
import { useDispatch } from "react-redux";
import { showToast } from "../../../store/toast/toastSlice";
import AddEditResumeModal from "./components/AddEditResumeModal";
import BaseConfirmModal from "../../../components/ui/BaseConfirmModal";

const AddEditResume = ({ resume, refetchMe, userId }) => {
  const dispatch = useDispatch();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isDeleteConfirmOpen, setIsDeleteConfirmOpen] = useState(false);

  const { isPending: isDeleting, mutateAsync: deleteResumeMutation } = useMutation({
    mutationFn: () => deleteUserResume(userId),
    enabled: false,
  });

  const handleDelete = async () => {
    try {
      await deleteResumeMutation();
      setIsDeleteConfirmOpen(false);
      dispatch(showToast({ message: "Resume deleted successfully", type: "success" }));
      refetchMe();
    } catch (error) {
      dispatch(showToast({ message: "Failed to delete resume", type: "error" }));
    }
  };

  return (
    <div className="mt-6 border-b pb-4">
      <div className="bg-light px-4 py-2 rounded-md flex justify-between items-center">
        <h6 className="text-dark font-normal">Resume</h6>
        <i
          className="fa-light fa-pencil text-gray-900 cursor-pointer" style={{ cursor: "pointer" }}
          onClick={() => setIsModalOpen(true)}
        ></i>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mt-4">
        {resume && (
          <div className="flex items-center justify-between gap-3 min-w-0 bg-light rounded-md py-3 px-4 border">
            <div className="flex items-center min-w-0">
              <i className="fa-regular fa-file-pdf text-xl text-red-500 shrink-0"></i>
              <p className="ml-3 text-sm truncate">{resume.filename}</p>
            </div>
            <div className="flex items-center shrink-0">
              <a href={resume.url} download target="_blank" rel="noreferrer" type="application/octet-stream">
                <i className="fa-solid fa-download mr-3 text-emerald-700 text-base cursor-pointer"></i>
              </a>
              <i
                className="fa-regular fa-trash-can text-red-600 cursor-pointer" style={{ cursor: "pointer" }}
                onClick={() => setIsDeleteConfirmOpen(true)}
              ></i>
            </div>
          </div>
        )}
      </div>

      {isModalOpen && (
        <AddEditResumeModal
          open={isModalOpen}
          close={setIsModalOpen}
          existingResume={resume}
          refetchMe={refetchMe}
          targetUserId={userId}
        />
      )}

      {isDeleteConfirmOpen && (
        <BaseConfirmModal
          open={isDeleteConfirmOpen}
          onClose={() => setIsDeleteConfirmOpen(false)}
          cancelText="Cancel"
          confirmText="Delete"
          confirmButtonColor="error"
          type="warning"
          title="Delete Resume"
          description="Are you sure you want to delete your resume? This action cannot be undone."
          isLoading={isDeleting}
          onConfirm={handleDelete}
        />
      )}
    </div>
  );
};

export default AddEditResume;
